import * as React from "react";
import { useTranslation } from "react-i18next";
import { Panel } from "spot-component-library/lib/components/basic/panel/Panel";
import { SPOTButton } from "spot-component-library/lib/components/SPOTButton";
import "./Finish.scss";

export const Finish = () => {
    const { t } = useTranslation();

    return (
        <div id={"form_sent_text"}>
            <Panel>
                <div className={"contact-form-finish-wrapper"}>
                    <div>
                        <b>{t("Finish.Message")}</b>
                        <p>{t("Finish.Received")}</p>
                        <p>{t("Finish.YourEOSTeam")}</p>
                    </div>

                    <SPOTButton type="primary" dataTest={"backToPageButton"} onClick={() => (window.location.href = "/")} label={t("Finish.Back")} />
                </div>
            </Panel>
        </div>
    );
};
